import React from 'react';

import SurfaceCard from 'ui/shared/SurfaceCard';

interface Props {
  children: React.ReactNode;
}

const ChainIndicatorsContainer = ({ children }: Props) => {
  return (
    <SurfaceCard
      px={{ base: 3, lg: 4 }}
      py={ 3 }
      columnGap={{ base: 3, lg: 4 }}
      rowGap={ 0 }
      flexBasis="50%"
      flexGrow={ 1 }
      alignItems="stretch"
      display="flex"
    >
      { children }
    </SurfaceCard>
  );
};

export default React.memo(ChainIndicatorsContainer);
